/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import {
  APPLICATION_STATUS_CONTRACT_BASE,
  APPLICATION_STATUS_CONTRACT_DESCRIPTION,
  APPLICATION_STATUS_CONTRACT_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_SUMMARY
} from "@/src/services/contractLaw/applicationStatus";
import React from "react";
import ProgressBar from "@/src/components/ProgressBar/ProgressBar";
import RentalContractBase from "@/src/components/Form/RentalContract/RentalContractBase";
import progressBarSteps from "./progressBarSteps";
import rentalContractFormSteps from "@/src/services/rentalContract/formSteps";
import { FormSteps } from "@/src/types/FormServiceBase";
import ContractDescription from "@/src/components/Form/RentalContract/ContractDescription";
import { APPLICATION_STATUS_CONTRACT_PARTY_TYPE } from "@/src/services/rentalContract/applicationStatus";
import RentalContractContractPartyType from "@/src/components/Form/RentalContract/RentalContractContractPartyType";
import { DocumentsForm } from "@/src/components/Form/DocumentsForm/DocumentsForm";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_CONTRACT_PARTY_TYPE]: {
    title: "Antrag - Ihre Rolle | Legalbird",
    applicationStatus: APPLICATION_STATUS_CONTRACT_PARTY_TYPE,
    stepUrl: "rolle",
    render: (props: any) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"contract"} progress={15} />
        <RentalContractContractPartyType {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT_BASE]: {
    ...rentalContractFormSteps[APPLICATION_STATUS_CONTRACT_BASE],
    render: (props: any) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"contract"} progress={50} />
        <RentalContractBase {...props} hideCaseCategories={true} alternativeHeadline="Ihre Angaben" />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT_DESCRIPTION]: {
    ...rentalContractFormSteps[APPLICATION_STATUS_CONTRACT_DESCRIPTION],
    render: (props: any) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"contract"} progress={50} />
        <ContractDescription
          {...props}
          alternateDescription={
            "Bitte schildern Sie uns hier kurz Ihre Situation und Fragen. Jede relevante Information hilft uns, Ihren Fall besser bearbeiten zu können. Im nächsten Schritt können Sie - wenn gewünscht - noch ergänzende Dokumente hochladen."
          }
        />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT_DOCUMENTS]: {
    ...rentalContractFormSteps[APPLICATION_STATUS_CONTRACT_DOCUMENTS],
    render: (props: any) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"documents"} progress={83} />
        <DocumentsForm submitProps={props.submitProps} product={props.product} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: rentalContractFormSteps[APPLICATION_STATUS_SUMMARY],
  [APPLICATION_STATUS_POWER_OF_ATTORNEY]: rentalContractFormSteps[APPLICATION_STATUS_POWER_OF_ATTORNEY],
  [APPLICATION_STATUS_DONE]: rentalContractFormSteps[APPLICATION_STATUS_DONE],
};

export default formSteps;
